import { render, staticRenderFns } from "./newPW.vue?vue&type=template&id=3134f354&scoped=true&"
import script from "./newPW.vue?vue&type=script&lang=js&"
export * from "./newPW.vue?vue&type=script&lang=js&"
import style0 from "./newPW.vue?vue&type=style&index=0&id=3134f354&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3134f354",
  null
  
)

export default component.exports